/* LMTM スクロールリビール
   指定の詳しい説明は lmtm-reveal.css の先頭コメントを参照。 */
(function () {
  var SELECTOR = '[data-lmtm-reveal], [data-lmtm-reveal-group] > *';
  var DEFAULT_STEP = 90;
  var MAX_STAGGER = 8; // 何十個あっても、これ以上は待たせない

  function stepOf(el) {
    var host = el.closest('[data-lmtm-reveal-group], [data-lmtm-reveal]');
    var value = parseInt(host && host.getAttribute('data-lmtm-reveal-step'), 10);
    return isNaN(value) ? DEFAULT_STEP : value;
  }

  function show(el, order) {
    el.style.setProperty('--lmtm-reveal-delay', Math.min(order, MAX_STAGGER) * stepOf(el) + 'ms');
    el.classList.add('is-revealed');
  }

  function init(root) {
    var targets = Array.prototype.slice
      .call((root || document).querySelectorAll(SELECTOR))
      .filter(function (el) {
        return !el.classList.contains('is-revealed');
      });

    if (targets.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        // 同時に入ってきたものだけを上から・左から並べ直して、順に遅延をつける。
        // ゆっくりスクロールして1つずつ入ってくるときは遅延なしで即出る。
        var entered = entries.filter(function (entry) {
          return entry.isIntersecting;
        });
        if (entered.length === 0) return;

        entered.sort(function (a, b) {
          var ay = Math.round(a.boundingClientRect.top / 8);
          var by = Math.round(b.boundingClientRect.top / 8);
          return ay - by || a.boundingClientRect.left - b.boundingClientRect.left;
        });

        entered.forEach(function (entry, index) {
          show(entry.target, index);
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.01 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  window.LmtmReveal = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // テーマカスタマイズでセクションを差し替えたときにも効かせる
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
